// const firebaseConfig = {
//     apiKey: "AIzaSyBgmemMJs_H24Ri8Vars0c7NlkeMqX1-MQ",
//     authDomain: "todofirebase-c0d28.firebaseapp.com",
//     projectId: "todofirebase-c0d28",
//     storageBucket: "todofirebase-c0d28.appspot.com",
//     messagingSenderId: "41081183438",
//     appId: "1:41081183438:web:3430f59998849171f3c49f"
//   };
  const firebaseConfig = {
    apiKey: "AIzaSyD7otLFTIFf2pnAW6UaYAqMVtVsp5VDS7c",
    authDomain: "todo-project-eeb2b.firebaseapp.com",
    projectId: "todo-project-eeb2b",
    storageBucket: "todo-project-eeb2b.appspot.com",
    messagingSenderId: "136267536818",
    appId: "1:136267536818:web:d30f74cdfdde2244adacab",
    measurementId: "G-MEW72SZPMR"
  };
  export default firebaseConfig